<!-- Trial banner -->
<div *ngIf="authenticated && trialDaysRemaining !== undefined" class="bg-warning text-dark text-center py-1 small fw-semibold">
  <span *ngIf="trialDaysRemaining > 0">{{ trialDaysRemaining }} day{{ trialDaysRemaining === 1 ? '' : 's' }} left in your free trial &mdash;</span>
  <span *ngIf="trialDaysRemaining === 0">Your free trial ends today &mdash;</span>
  <a routerLink="/account/subscription" class="text-dark fw-bold text-decoration-underline ms-1">Subscribe now</a>
</div>
  <!-- Navbar -->
  <!-- Remove "navbar-sticky" class to make navigation bar scrollable with the page -->
  <header class="header navbar navbar-expand-lg bg-light border-bottom border-light shadow-sm fixed-top">
    <div class="container px-3">
      <a routerLink='/' class="navbar-brand pe-3">
        <img src="/assets/img/logo.svg" width="220" alt="CourseSignage.com">
      </a>
      <div id="navbarNav" class="offcanvas offcanvas-end bg-dark">
        <div class="offcanvas-header border-bottom border-light">
          <h5 class="offcanvas-title text-white">Menu</h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas"
            aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li *ngIf="!authenticated" class="nav-item dropdown">
              <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link dropdown-toggle" data-bs-toggle="dropdown"
                aria-current="page">Home</a>
              <div class="dropdown-menu dropdown-menu-dark p-0">
                <div class="d-lg-flex">
                  <div
                    class="mega-dropdown-column d-flex justify-content-center align-items-center rounded-3 rounded-end-0 px-0"
                    style="margin: -1px; background-color: #f3f6ff;">
                    <img src="assets/img/landings.jpg" alt="Landings">
                  </div>
                  <div class="mega-dropdown-column pt-lg-3 pb-lg-4" style="--si-mega-dropdown-column-width: 15rem;">
                    <ul class="list-unstyled mb-0">
                      <li><a routerLink="/" fragment="features" class="dropdown-item">Features</a></li>
                      <li><a routerLink="/" fragment="how-it-works" class="dropdown-item">How does it work?</a></li>
                      <li><a routerLink="/pricing" class="dropdown-item">Pricing</a></li>
                      <li><a routerLink="/signup" class="dropdown-item">Get Started</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li *ngIf="authenticated" class="nav-item">
              <a routerLink="/courses" routerLinkActive="active" class="nav-link">Courses</a>
            </li>
            <li *ngIf="authenticated" class="nav-item">
              <a routerLink="/account" routerLinkActive="active" class="nav-link">Account</a>
            </li>
            <li *ngIf="!authenticated" class="nav-item">
              <a routerLink="/pricing" routerLinkActive="active" class="nav-link">Pricing</a>
            </li>
            <li *ngIf="!authenticated" class="nav-item">
              <a routerLink="/contact" routerLinkActive="active" class="nav-link">Contact</a>
            </li>
            <li class="nav-item">
              <a href="https://discord.gg/KWQ8cnfD" target="_blank" rel="noopener noreferrer" class="nav-link d-flex align-items-center gap-1">
                <i class="bx bxl-discord-alt fs-5"></i>
                Community
              </a>
            </li>
          </ul>
        </div>
        <div *ngIf="!authenticated" class="offcanvas-header border-top border-light">
          <a routerLink="/signup" class="btn btn-primary w-100">
            <i class="bx bx-rocket fs-4 lh-1 me-1"></i>
            &nbsp;Get Started
          </a>
        </div>
      </div>
      <button type="button" class="navbar-toggler" data-bs-toggle="offcanvas" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <button
        *ngIf="authenticated"
        type="button"
        class="btn btn-sm rounded d-none d-lg-inline-flex align-items-center gap-1 me-2"
        [class.btn-primary]="assistantOpen"
        [class.btn-outline-secondary]="!assistantOpen"
        (click)="toggleAssistant()"
        aria-label="Toggle AI assistant"
        aria-controls="assistantTray"
        [attr.aria-expanded]="assistantOpen"
      >
        <i class="bx fs-5 lh-1" [class.bx-bot]="!assistantOpen" [class.bxs-bot]="assistantOpen"></i>
        Assistant
      </button>
      <a *ngIf="!authenticated" routerLink="/signup" class="btn btn-primary btn-sm fs-sm rounded d-none d-lg-inline-flex">
        <i class="bx bx-rocket fs-5 lh-1 me-1"></i>
        &nbsp;Get Started
      </a>
    </div>
  </header>